import React, {useState, useContext, useEffect} from 'react';
import { UserRegistrationContext } from "./ShareStates";
import CustomerErrorMessage from "./CustomerErrorMessage";
import {
    getUserRegisterZipcodeQuery,
    getQueryResult
} from "../../commonFunctions/GraphqlFunctions";

const ZipForm = () => {
    const {
        serialNumber1,
        // serialNumber2,
        zipcode,
        updateDisplayForm,
        updateZipcode,
        updatePreviousForm
    } = useContext(UserRegistrationContext);
    const [zipValue, setZipValue] = useState("");
    const [zipValueError, setZipValueError] = useState("");
    const [mountReadOnce, setMountReadOnce] = useState("none");
    const [displayErrorNotice, setDisplayErrorNotice] = useState("none");
    const [displayErrorNoticeCustomerValue, setDisplayErrorNoticeCustomerValue] = useState("none");
    const [displayErrorNoticeGraphQLValue, setDisplayErrorNoticeGraphQLValue] = useState("none");

    useEffect(() => {
        if (mountReadOnce === "none") {
            setZipValue(zipcode);
            setMountReadOnce("visited");
        }
    }, [mountReadOnce, zipcode, setMountReadOnce, setZipValue]);

    const inputChange = (event) => {
        event.preventDefault();
        setZipValue(event.target.value);
    }

    const backButtonAction = (event) => {
        event.preventDefault();
        updateZipcode(zipValue);
        updateDisplayForm("serialNumberForm");
    }

    const getDisplayErrorNotice = (errorType, error) => {
        if (errorType === 'message') {
            console.log(error);
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("block");
        }
        if (errorType === 'customer') {
            setDisplayErrorNotice("block");
            setDisplayErrorNoticeCustomerValue("block");
            setDisplayErrorNoticeGraphQLValue("none");
        }
        if (errorType === 'none') {
            setDisplayErrorNotice("none");
            setDisplayErrorNoticeCustomerValue("none");
            setDisplayErrorNoticeGraphQLValue("none");
        }
    }

    const nextButtonAction = async (event) => {
        event.preventDefault();
        if (zipValue.trim() === "") {
            setZipValueError("Please input a zipcode")
        }
        else {
            let getUserRegisterZipcodeResult = await getQueryResult(
                    getUserRegisterZipcodeQuery(),
                    {"serialNumber1": serialNumber1, "zipcode": zipValue});
            // console.log(getUserRegisterZipcodeResult);
            if (getUserRegisterZipcodeResult !== undefined) {
                if (getUserRegisterZipcodeResult.data['supportSiteUserRegisterCheckZipcode']['message'] !== undefined) {
                    let messageOutput = getUserRegisterZipcodeResult.data['supportSiteUserRegisterCheckZipcode']['message'];
                    if (messageOutput === "no zipcode found" || messageOutput === "no match zipcode found") {
                        getDisplayErrorNotice("customer", getUserRegisterZipcodeResult.data['supportSiteUserRegisterCheckZipcode']['message']);
                    }
                    else {
                        getDisplayErrorNotice("message", getUserRegisterZipcodeResult.data['supportSiteUserRegisterCheckZipcode']['message']);
                    }
                }
                else {
                    let customerName = getUserRegisterZipcodeResult.data['supportSiteUserRegisterCheckZipcode']['customer']
                    if (customerName === "") {
                        getDisplayErrorNotice("customer", "customer not found");
                    }
                    else {
                        updateZipcode(zipValue);
                        updatePreviousForm("zipForm");
                        updateDisplayForm("accountForm");
                    }
                }
            }
            else {
                getDisplayErrorNotice("message", getUserRegisterZipcodeResult);
            }
        }
    }

    return (
        <div>
            <React.Fragment>
                <fieldset name={"zipStep"} style={{display: "block"}}>
                    <h1>We need a little more information</h1>
                    <div className={"errorNotice"} style={{display: displayErrorNotice}}>
                        <div style={{display: displayErrorNoticeCustomerValue}}>
                            {CustomerErrorMessage()}
                        </div>
                        <div style={{display: displayErrorNoticeGraphQLValue}}>
                            There is error contacting the backend server, please contact administrator.
                        </div>
                    </div>
                    <input type={"text"} name={"zip"} id={"zip"} className={"required activate"} placeholder={"Enter zip"} value={zipValue} onChange={inputChange}></input>
                    <span id={"error_zip"} className={"error"}>{zipValueError}</span>
                    <div style={{width: '100%'}}>
                        <div style={{width: '50%', float: 'left', paddingRight: '10px'}}>
                            <button type={"button"} className={"backButton btn"} title={"Next"} onClick={backButtonAction}>
                                <span>Back</span>
                            </button>
                        </div>
                        <div style={{width: '50%', float: 'right', paddingLeft: '10px'}}>
                            <button type={"submit"} className={"nextButton btn"} title={"Next"} onClick={nextButtonAction}>
                                <span>Next</span>
                            </button>
                        </div>
                        <div style={{clear: "both"}}></div>
                    </div>
                </fieldset>
            </React.Fragment>
        </div>
    )
}

export default ZipForm;